/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Alert/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import AlertIcon from './AlertIcon/index'
import Body from './Body/index'
import Header from './Header/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Alert({
  children,
  viewPath = "/App/Account/PatientNotifications/Content/Content/Content/Alerts/Alert"
  
}) {
let alertItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'alert_item',
path: 'isFirst',
})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Alert.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-4z5bt': dtColorsNeutral200,'--mt-3-4z5bt': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-4-4z5bt': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btw-2-4z5bt': alertItemIsFirstValueData ? "0px" : "1px"}}
 className={`views-block ${styles.Horizontal}`}
>
<AlertIcon
  viewPath={`${viewPath}/AlertIcon`}
/>
<div
  data-testid="Alert.Vertical"
  data-view-path={viewPath}
 style={{'--ml-5-4z5bt': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<Body
  viewPath={`${viewPath}/Body`}
/>
<Header
  viewPath={`${viewPath}/Header`}
/>
</div>
</div>
{children}
</React.Fragment>)
}